<template>
    <div class="main">
        <!-- Edit account details -->
        <div class="manageAccount__container mx-auto py-16">
            <div class="text-center w-2/5 md:w-1/4 mx-auto">
                <img class="mx-auto" src="@/assets/images/pages/account/manage-account/id-card-icon.svg">
            </div>
            <h2 class="text-center p-3 m-0" v-text="$t('MANAGE_ACCOUNT_UPDATE')"></h2>
            <edit-account-details-form></edit-account-details-form>
        </div>

        <div class="divider--container background--paper clear--sm">
            <div class="divider-white--top"></div>
            <div class="divider-white--bottom"></div>
        </div>

        <!--Edit card details-->
        <div class="manageAccount__container mx-auto py-16 text-center" id="billingAddressForm">
            <h2 v-text="$t('MANAGE_ACCOUNT_CARD_DETAILS')"></h2>
            <div v-if="!showCardForm">
                <p class="mt-4" v-text="$t('MANAGE_ACCOUNT_CARD_NUMBER')"></p>
                <p v-if="cardEnding">---- ---- ---- {{ cardEnding }}</p>
                <p v-if="user.payment_method === 'paypal'">
                    <img class="paypal-icon" src="@/assets/images/icons/paypal-icon.svg" alt="Paypal Logo">
                </p>
                <div class="w-full mt-4">
                    <button class="btn btn--primary" @click="showCardForm = true"
                        v-text="$t('MANAGE_ACCOUNT_CHANGE_CARD')">
                    </button>
                </div>
            </div>

            <edit-card-details-form
                class="mt-4"
                v-if="showCardForm"
                :orderValue="orderValue"
                @closed="showCardForm = false">
            </edit-card-details-form>
        </div>

        <div class="divider--container background--paper clear--sm">
            <div class="divider-white--top"></div>
            <div class="divider-white--bottom"></div>
        </div>

        <!-- Billing details -->
        <div class="bg-white px-8 py-16" id="manageBllingContainer">
            <div class="container accountDeliveryAddresses__container mx-auto text-center">
                <h2 class="pb-4" v-text="$t('MANAGE_ACCOUNT_YOUR_BILLING_ADDRESS')"></h2>
                <manage-billing-address></manage-billing-address>

                <router-link class="link" :to="{name:'account.delivery-addresses'}">
                   {{ $t('MANAGE_ACCOUNT_MANAGE_DELIVERY') }}
                </router-link>
            </div>
        </div>

        <div class="background--paper divider--container">
            <div class="divider-white--top"></div>
            <div class="manageAccount__container mx-auto text-center py-16">
                <h2 v-text="$t('MANAGE_ACCOUNT_PAYMENT_HISTORY')"></h2>
                <orders-list></orders-list>
                <div class="divider-white--bottom"></div>
            </div>
        </div>

        <div class="bg-white">
            <div class="manageAccount__container mx-auto py-8">
                <div class="w-1/2 mx-auto text-center">
                    <p v-html="$t('MANAGE_ACCOUNT_TO_CANCEL', { phone, email })"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import EditCardDetailsForm from '@/components/forms/account/EditCardDetailsForm';
import EditAccountDetailsForm from '@/components/forms/account/EditAccountDetailsForm';
import OrdersList from '@/components/partials/account/manage-account/OrdersList';
import ManageBillingAddress from '@/components/partials/account/my-delivery-addresses/ManageBillingAddress';

export default {
    name: 'ManageAccount',
    data() {
        return {
            showCardForm: false,
            phone: process.env.VUE_APP_TELEPHONE,
            email: process.env.VUE_APP_EMAIL,
        };
    },
    mounted() {
        this.$store.dispatch('address/fetchAllAddresses', true);
        this.$store.dispatch('cookies/mountPrimer');

        if (this.hasPendingSubscription) {
            this.$scrollTo('#billingAddressForm');
        }
        if (this.expandFormName) {
            this.showCardForm = true;
            this.$scrollTo(`#${this.expandFormName}`);
            this.expandFormName = null;
        }

        this.$root.$off('close-card-form');
        this.$root.$on('close-card-form', (paymentMethod) => {
            this.addNewCardDetails(paymentMethod.token, paymentMethod.payment_method);
        });
    },
    created() {
        this.$store.dispatch('cookies/mountStripe');
    },
    methods: {
        ...mapActions({
            updatePaymentSource: 'payment/updatePaymentSource',
        }),

        addNewCardDetails(token, type) {
            const payload = {
                card_token: token,
                gateway: 'Primer',
                name_on_card: `${this.billingAddress.first_name} ${this.billingAddress.last_name}`,
                payment_method: type,
            };

            this.updatePaymentSource({ userId: this.userId, data: payload }).then((res) => {
                this.showCardForm = false;
            }).catch((error) => this.$root.$emit('payment-error', error));
        },
    },
    computed: {
        ...mapGetters({
            hasPendingSubscription: 'subscription/hasPendingSubscription',
            userId: 'account/getUserId',
            billingAddress: 'payment/getBillingAddress',
            user: 'account/getUser',
        }),
        orderValue() {
            return process.env.VUE_APP_BOX_PRICE * 100;
        },
        cardEnding() {
            return this.$store.getters['payment/getCardEnding'];
        },
        expandFormName: {
            get() {
                return this.$store.getters['account/getExpandFormName'];
            },
            set(value) {
                this.$store.commit('account/updateExpandFormName', value);
            },
        },
    },
    components: {
        EditAccountDetailsForm,
        EditCardDetailsForm,
        ManageBillingAddress,
        OrdersList,
    },
};
</script>

<style scoped>
.paypal-icon {
    width: 100px;
    margin: 0 auto;
}
</style>
